import React from 'react';
import { Divider, Typography } from '@mui/material';
import jute from '../../../../../images/Agri-info/crops/Jute_পাট.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const JuteInfo = () => {

    // dynamic title
    useDocumentTitle("পাট");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                পাট
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={jute} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text"><b>পাট চাষ ব্যবস্থাপনা<br />মৌসুম:</b><br />
                                পাট উৎপাদন মৌসুম (বপন থেকে পাট কাটা) হচ্ছে ফাল্গুনের শেষ থেকে আষাঢ়ের শেষ পর্যন্ত।</p>
                            <p className="card-text"><b>জাত : </b><br />আঁশ ফসলের জন্য চার ধরনের পাট রয়েছে। দেশী পাট, তোষা পাট, কেনাফ ও মেস্তা পাট।</p>
                            <p className="card-text"><b>জমি তৈরিকরণঃ</b><br />উঁচু ও মধ্যম উঁচু জমি যেখানে বৃষ্টির পানি বেশি সময় দাঁড়ায় না এবং দো-আঁশ মাটি পাট চাষের জন্য বেশি উপযোগী। বৃষ্টিপাতের পরপরই আড়াআড়ি ৫-৭ টি চাষ দিয়ে জমি তৈরি করতে হবে। ঢেলা গুড়ো করতে হবে এবং জমি আগাছামুক্ত করতে হবে।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p className="card-text"><b>সার প্রয়োগ : </b><br />ভালোভাবে প্রস্তুতকৃত জমিতে বপনের ২-৩ সপ্তাহ আগে হেক্টরপ্রতি ৩.৫ টন গোবর সার মিশিয়ে দিতে হবে। বপনের দিন</p>
                <p>১৫ কেজি ইউরিয়া<br />১৭ কেজি টিএসপি ও<br />২২ কেজি এমওপি সার জমিতে প্রয়োগ করতে হবে।</p>
                <p>অত:পর বীজ বপনের ৬-৭ সপ্তাহ পর ক্ষেতের আগাছা পরিষ্কার ও চারা পাতলা করে হেক্টরপ্রতি ১০০ কেজি ইউরিয়া সার জমিতে পুনরায় ছিটিয়ে দিতে হবে।</p>

                <p className="card-text"><b>বীজ বপন : </b><br />সময়মত পাটবীজ বপন করা উচিত। সাধারণত: ছিটিয়েই পাটবীজ বপন করা হয়। তবে সারিতে বপন করলে পাটের ফলন বেশি হয়।</p>
                <p className="card-text"><b>বীজ হার : </b><br />ছিটিয়ে বুনলে-৬.৫-৭.৫ কেজি/হেক্টর, সারিতে বুনলে-৩.৫-৫.০০ কেজি/হেক্টর</p>
                <p>সারিতে বুনলে লাইন থেকে লাইনের দূরত্ব ৩০ সেমি বা এক ফুট এবং গাছ থেকে গাছের দূরত্ব ৭-১০ সেমি বা ৩-৪ ইঞ্চি হতে হবে।</p>
                <p className="card-text"><b>আগাছা দমন ও চারা পাতলাকরণ : </b><br />বীজ বপনের ১৫-২১ দিনের মধ্যে ১ম নিড়ানী এবং ৩৫-৪২ দিনের মধ্যে ২য় নিড়ানী দিয়ে আগাছা দমন ও চারা পাতলা করতে হবে।</p>
                <p className="card-text"><b>পাটের পোকামাকড় ও রোগ ব্যবস্থাপনা : </b><br /> সারণী-১। পাটের প্রধান প্রধান পোকামাকড় দমন ব্যবস্থাপনা</p>
                <p className="card-text"><b>২. ঘোড়া পোকা  </b><br /><b>ক্ষতির ধরণ : </b>ডগার দিকের কচি পাতা খেয়ে ফেলে।<br /><b>দমন পদ্ধতি :</b><br />
                    ১. কেরোসিনে ভেজানো দড়ি গাছের ওপর দিয়ে টেনে দেয়া।<br />
                    ২. ক্ষেতে ডালপালা পুঁতে পাখি বসার জায়গা করে দেয়া যাতে করে পাখিরা পোকা খেয়ে এদের সংখ্যা কমিয়ে দিতে পারে।<br />
                    ৩. ডায়াজিনন ৬০% তরল/ ইকালাক্স ২৫% তরল অনুমোদিত মাত্রায় জমিতে প্রয়োগ করা যেতে পারে। </p>
                <p className="card-text"><b>৩. উড়চুঙ্গাঁ  </b><br /><b>ক্ষতির ধরণ : </b>জমিতে গর্ত করে চারা গাছের গোড়া কেটে দেয়। <br /><b>দমন পদ্ধতি :</b><br />
                    ১. ক্ষেতে পানি সেচ দিয়ে দিলে পোকা মাটি থেকে বের হয়ে আসবে। অত:পর পোকা ধ্বংশ করে ফেলা।<br />
                    ২. বিষটোপ ব্যবহার করে অথবা রিপকর্ড ১০ ইসি অনুমোদিত মাত্রায় ক্ষেতে প্রয়োগ করা যেতে পারে। </p>
                <p className="card-text"><b>৪. চেলে পোকা</b><br /><b>ক্ষতির ধরণ : </b>কান্ডে ছিদ্র করে ফলে আঁশ ছিঁড়ে যায়।<br /><b>দমন পদ্ধতি :</b><br />
                    ১. মৌসুমের শুরুতে আক্রান্ত গাছগুলো তুলে নষ্ট করে ফেলা।<br />
                    ২. ক্ষেতের ও আশপাশের আগাছা পরিষ্কার রাখা।<br />
                    ৩. গাছের উচ্চতা ৫-৬ ইঞ্চি হলে ম্যাটসিসটক্স ৫০% তরল/ডায়াজিনন ৬০% তরল/নুভক্রিন ৪০% তরল অনুমোদিত মাত্রায় আক্রান্ত ক্ষেতে সেপ্র করলে পোকা দমন হয়। </p>
                <p className="card-text"><b>৫. সাদা ও লাল মাকড় </b><br /><b>ক্ষতির ধরণ : </b>ডগার পাতার রস চুষে খায়, ফলে পাতা কুঁকড়ে যায়।   <br /><b>দমন পদ্ধতি :</b><br />
                    ১. প্রচুর বৃষ্টিপাত হলে প্রাকৃতিকভাবেই এই কীট দমন হয়।<br />
                    ২. আক্রমণ বেশি হলে থিওভিট ৮০% পাউডার/ইসিওন ৪৩% তরল অনুমোদিত মাত্রায় প্রয়োগ করা যেতে পারে।</p>
                <p><b>পাটের প্রধান প্রধান রোগ দমন ব্যবস্থা<br />চারায় মড়ক</b></p>
                <p className="card-text"><b>ক্ষতির ধরণ: </b><br />গোড়ায় কালো দাগ ধরে চারা মারা যায়।</p>
                <p className="card-text"><b>ব্যবস্থাপনা:</b><br />
                    ১. মরা চারা তুলে পুড়িয়ে ফেলা।<br />
                    ২. ভিটাভেক্স ২০০ (০.৪%) দিয়ে বীজ শোধন করা।<br />
                    ৩. ডাইথেন এম-৪৫ হেক্টরপ্রতি ৩০ লিটার পানির সাথে ২৫/৩০ গ্রাম হারে মিশিয়ে ৩/৪ দিন পরপর ২/৩ পর ক্ষেতে ছিটালে এ রোগ দূর হয়।</p>
                <p className="card-text"><b>ঢলে পড়া </b><br /><b>ক্ষতির ধরণ: </b> ছোট বড় উভয় অবস্থায় শিকড়ে এ রোগের জীবাণু আক্রমণ করলে গাছ ঢলে পড়ে।</p>
                <p className="card-text"><b>ব্যবস্থাপনা:</b><br />
                    ১. জমিতে পানি থাকলে তা সরিয়ে ফেলা।<br />
                    ২. ক্ষেত আবর্জনামুক্ত রাখা।<br />
                    ৩. পাট কাটার পর গোড়া, শিকড় ও অন্যান্য পরিত্যক্ত অংশ পুড়িয়ে ফেলা।<br />
                    ৪. ডাইথেন এম-৪৫ অনুমোদিত মাত্রায় ক্ষেতে প্রয়োগ করা যেতে পারে।</p>

            </div >
        </div >

    );
};

export default JuteInfo;